module.exports = __webpack_public_path__ + "static/media/ide.6249d650.png";